import { Grid, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { postMessage } from '../../../utils/postMessage';

const OrderSummaryHeader = (props) => {
  const { classes, thumbnailUrl, modifyOrderLink, hideModifyOrderLink } = props;
  return (
    <Grid item container className={classes.itemContainer}>
      <Grid item xs={12} lg={6} className={classes.reviewOrderDetailsImage}>
        <img
          style={{ height: '25px' }}
          src={thumbnailUrl}
          alt="order-summary-product-thumbnail"
        />
      </Grid>
      {!hideModifyOrderLink && (
        <Grid
          item
          className={`pageLink subscription ${classes.modifyOrderText}`}
          xs={12}
          sm={6}
        >
          <Typography variant="body1">
            <Link
              to="/#"
              className={classes.link}
              onClick={() => {
                postMessage('payment.modifyOrder', {});
              }}
            >
              {modifyOrderLink}
            </Link>
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default OrderSummaryHeader;
